import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';
import { TelegramIcon, LogoIcon, WhatsAppIcon } from '../../Other/Icons/Icons';
import Button from '../../Buttons/Button/Button';
import { useScroll } from '../../../context/ScrollContext';

const Header = () => {
  // Инициализация хука перевода
  const { t, i18n } = useTranslation();
  // Состояние для отображения выпадающего меню сервисов
  const [showServicesMenu, setShowServicesMenu] = useState(false);
  // Состояние для мобильного меню
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Состояние для определения ширины экрана
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  // Определяем тип устройства на основе ширины экрана
  const isDesktop = windowWidth >= 1000;
  const isTablet = windowWidth >= 768 && windowWidth < 1000;
  const isMobile = windowWidth < 768;
  
  const { scrollTo } = useScroll();
  
  useEffect(() => {
    console.log('Компонент Header загружен. Тексты из локализации');
    console.log('Текущий язык:', i18n.language);
    console.log('Пример текста phone:', t('header.phone'));
    console.log('Доступные ресурсы:', i18n.options.resources);
  }, [t, i18n]);

  // Эффект для отслеживания изменения размеров окна
  useEffect(() => {
    const handleResize = () => {
      console.log('Изменение размера окна:', window.innerWidth);
      setWindowWidth(window.innerWidth);
      // Закрываем мобильное меню при изменении размера окна на десктоп
      if (window.innerWidth >= 1000) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const handleOrderClick = () => {
    console.log('Нажата кнопка заказа');
    scrollTo('requestForm');
  };

  // Обработчик для показа/скрытия выпадающего меню
  const toggleServicesMenu = () => {
    console.log('Переключение меню сервисов');
    setShowServicesMenu(!showServicesMenu);
  };

  // Обработчик для переключения мобильного меню
  const toggleMobileMenu = () => {
    console.log('Переключение мобильного меню');
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  return (
    <header className={`${styles.header} ${isTablet ? styles.tabletHeader : ''} ${isMobile ? styles.mobileHeader : ''}`}>
      <div className={styles.headerContainer}>
        {/* Верхний блок контактов - показываем на десктопе и планшете */}
        {isDesktop && (
          <div className={styles.container}>
            <div className={styles.side_block}>
              <div className={styles.contact_block}>
                <span>
                  {t('header.phone')}
                </span>
                <span>
                  {t('header.workingHours')}
                </span>
                <a href="https://t.me/yourcompany" target="_blank" rel="noopener noreferrer" className={`${styles.socialLink} ${styles.telegramLink}`}>
                  <TelegramIcon color="#FFFFFF" />
                </a>
                <a href="https://wa.me/79999999999" target="_blank" rel="noopener noreferrer" className={`${styles.socialLink} ${styles.whatsappLink}`}>
                  <WhatsAppIcon color="#FFFFFF" />
                </a>
              </div>
            </div>
            <div className={styles.side_block}>
              <div className={styles.info_block}>
                {t('header.weekendNote')}
              </div>
            </div>
          </div>
        )}
        
        {/* Блок с телефоном и часами работы для планшета */}
        {isTablet && (
          <div className={styles.tabletContactContainer}>
            <div className={styles.tabletContactInfo}>
              <div className={styles.tabletPhone}>
                {t('header.phone')}
              </div>
              <div className={styles.tabletWorkingHours}>
                {t('header.workingHours')}
              </div>
            </div>
          </div>
        )}
        
        {/* Основной блок навигации */}
        <div className={styles.container}>
          <div className={styles.side_block}>
            <Link to="/" className={styles.logo}>
              <LogoIcon color="#fff"/>
            </Link>
            
            {/* Навигация на десктопе */}
            {isDesktop && (
              <div className={styles.nav_block}>
                <div className={styles.nav_item}>
                  <Link to="/">{t('header.navigation.home')}</Link>
                </div>
                <div className={styles.nav_item}>
                  <Link to="/prices">{t('header.navigation.services')}</Link>
                </div>
                <div className={styles.nav_item}>
                  <Link to="/contacts">{t('header.navigation.contacts')}</Link>
                </div>
                {/* <div className={styles.nav_item}>
                  <Link to="/about">{t('header.navigation.about')}</Link>
                </div> */}
              </div>
            )}
          </div>
          
          <div className={styles.side_block}>
            {/* Кнопка заказа на десктопе */}
            {isDesktop && (
              <Button 
                text={t('header.orderButton')} 
                onClick={handleOrderClick} 
                type="primary"
              />
            )}
            
            {/* Бургер-кнопка на планшете и телефоне */}
            {!isDesktop && (
              <button 
                className={styles.burgerButton} 
                onClick={toggleMobileMenu}
                aria-label="Мобильное меню"
              >
                <span className={`${styles.burgerLine} ${isMobileMenuOpen ? styles.active : ''}`}></span>
                <span className={`${styles.burgerLine} ${isMobileMenuOpen ? styles.active : ''}`}></span>
                <span className={`${styles.burgerLine} ${isMobileMenuOpen ? styles.active : ''}`}></span>
              </button>
            )}
          </div>
        </div>
        
        {/* Мобильное меню для планшета и телефона */}
        {!isDesktop && (
          <div className={`${styles.mobileMenu} ${isMobileMenuOpen ? styles.mobileMenuOpen : ''}`}>
            <div className={styles.mobileNav}>
              <div className={styles.mobileNavItem}>
                <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>{t('header.navigation.home')}</Link>
              </div>
              <div className={styles.mobileNavItem}>
                <Link to="/prices" onClick={() => setIsMobileMenuOpen(false)}>{t('header.navigation.services')}</Link>
              </div>
              <div className={styles.mobileNavItem}>
                <Link to="/contacts" onClick={() => setIsMobileMenuOpen(false)}>{t('header.navigation.contacts')}</Link>
              </div>
              
              <div className={styles.mobileContactBlock}>
                {/* На телефоне показываем телефон и часы работы в меню */}
                {isMobile && (
                  <>
                    <div className={styles.mobilePhone}>{t('header.phone')}</div>
                    <div className={styles.mobileWorkingHours}>{t('header.workingHours')}</div>
                  </>
                )}
                
                {/* Показываем социальные сети в меню для обоих типов устройств */}
                <div className={styles.mobileSocials}>
                  <a href="https://t.me/yourcompany" target="_blank" rel="noopener noreferrer">
                    <TelegramIcon color="#FFFFFF" size={32}/>
                  </a>
                  <a href="https://wa.me/79999999999" target="_blank" rel="noopener noreferrer">
                    <WhatsAppIcon color="#FFFFFF" size={32}/>
                  </a>
                </div>
                
                {/* Кнопка заказа в мобильном меню для обоих типов устройств */}
                <Button 
                  text={t('header.orderButton')} 
                  onClick={handleOrderClick} 
                  type="primary"
                />
                
                {/* Дополнительная информация внизу меню */}
                <div className={styles.mobileInfo}>
                  {t('header.weekendNote')}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header; 